import {
  METRIC_RANK_SCORE_BARRIERS,
  METRIC_RANK_DEFAULT,
  METRIC_RANK_COLORS,
  METRIC_RANK_BARRIERS,
  METRIC_TYPE_CLOSED_DEALS,
  METRIC_TYPE_MET_CLIENTS,
  METRIC_TYPE_STATUS_UPDATED,
  METRIC_TYPE_CLAIMED_LEADS,
  METRIC_TYPE_CONTACTING_REFERRALS,
} from 'common/constants'

export const getColorForAgentScore = score => {
  const rank = getRankForScore(score)
  return METRIC_RANK_COLORS[rank]
}

export const getRankForPercentile = percentile => {
  return METRIC_RANK_BARRIERS.findIndex(minForRank => percentile >= minForRank)
}

export const getColorForRank = (rank = METRIC_RANK_DEFAULT) => {
  return METRIC_RANK_COLORS[rank]
}

export const getColorForPercentile = percentile => getColorForRank(getRankForPercentile(percentile))

export const getRankForScore = score => {
  const rank = METRIC_RANK_SCORE_BARRIERS.findIndex(minForRank => score && score >= minForRank)
  return rank < 0 ? METRIC_RANK_DEFAULT : rank
}

export const getMetricDescription = (metricType, numerator, denominator) => {
  switch (metricType) {
    case METRIC_TYPE_CLOSED_DEALS:
      return `${numerator} closed out of ${denominator} met`
    case METRIC_TYPE_MET_CLIENTS:
      return`${numerator} of ${denominator} met in first 2 weeks`
    case METRIC_TYPE_STATUS_UPDATED:
      return `${Math.round(numerator / (denominator || 1) * 100)}% updated weekly`
    case METRIC_TYPE_CLAIMED_LEADS:
      return `${Math.round(numerator / (denominator || 1) * 100)}% attempted to claim`
    case METRIC_TYPE_CONTACTING_REFERRALS:
      return `${Math.round(numerator / (denominator || 1) * 100)}% of referrals messaged/called`
  }
  return ''
}